/**
 * Статические режимы питания для фильтров отчётов
 */
export type FoodModeItem = {
  id: 'breakfast' | 'dinner' | 'afternoon'
  title: string
}

export const foodModes: Array<FoodModeItem> = [
  { id: 'breakfast', title: 'Завтрак' },
  { id: 'dinner', title: 'Обед' },
  { id: 'afternoon', title: 'Полдник' },
]
